import UserIcon from './component'

export default UserIcon
